import { useCallback, useEffect, useState } from "react";
import styles from "./Pagination.module.scss";
import { ChevronLeft, ChevronRight, ChevronTop } from "@monta/icons";
import clsx from "clsx";
import DropDown, { useDropDown } from "../DropDown";

export interface PaginationProps {
  dataSize: number;
  value: number;
  onChange: (value: number, size: number) => void;
}

const sizeOptions = [
  { label: "5 ردیف", value: 5 },
  { label: "10 ردیف", value: 10 },
  { label: "25 ردیف", value: 25 },
  { label: "50 ردیف", value: 50 },
  { label: "100 ردیف", value: 100 },
];

const Pagination = (props: PaginationProps) => {
  const { dataSize, onChange, value } = props;

  const [size, setSize] = useState(5);

  const clickHandler = useCallback(
    (value: number) => () => {
      if (value >= 1 && value <= maxPage) onChange?.(value, size);
    },
    [onChange],
  );

  useEffect(() => {
    onChange?.(value, size);
  }, [size]);

  function range(size, startAt = 0) {
    return [...Array(size).keys()].map((i) => (
      <div
        className={clsx(value == i + startAt && styles["active"])}
        onClick={clickHandler(i + startAt)}
      >
        {i + startAt}
      </div>
    ));
  }

  const maxPage = Math.ceil(dataSize / size);
  const controller = useDropDown();

  return (
    <div className={styles["wrapper"]}>
      <div className={styles["wrapper__page-size"]}>
        <span>تعداد ردیف هر صفحه:</span>
        <DropDown
          {...controller}
          sameWidthAsInput
          stayOpenOnClick
          nudgeY={8}
          button={
            <div
              className={clsx(
                styles["size"],
                controller.isOpen && styles["size--open"],
              )}
              onClick={controller.open}
            >
              {sizeOptions.find((i) => i.value == size)?.label}
              <ChevronTop />
            </div>
          }
        >
          <div className={styles["size__list"]}>
            {sizeOptions.map((i) => (
              <div
                onClick={() => {
                  setSize(i.value);
                  controller.close();
                }}
              >
                {i.label}
              </div>
            ))}
          </div>
        </DropDown>
      </div>
      <div className={styles["wrapper__page"]}>
        <ChevronLeft onClick={clickHandler(value - 1)} />
        {maxPage < 6 ? (
          range(maxPage, 1)
        ) : value < maxPage - 4 ? (
          <>
            {range(4, value)}
            <div>...</div>
            <div
              className={clsx(value == maxPage && styles["active"])}
              onClick={clickHandler(maxPage)}
            >
              {maxPage}
            </div>
          </>
        ) : (
          <>
            <div
              className={clsx(value == 1 && styles["active"])}
              onClick={clickHandler(1)}
            >
              1
            </div>
            <div>...</div>
            {range(5, maxPage - 4)}
          </>
        )}
        <ChevronRight onClick={clickHandler(value + 1)} />
      </div>
    </div>
  );
};

export default Pagination;
